import React, { PropsWithChildren } from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: "0 auto",
      position: "relative",
    },
  })
)
export default function ContentWrapper({ children }: PropsWithChildren<{}>) {
  const classes = useStyles()
  return <div className={classes.root}>{children}</div>
}
